import api from './api';

export const getInstallations = async () => {
  const { data } = await api.get('/installations');
  return data;
};

export const getInstallation = async (id) => {
  const { data } = await api.get(`/installations/${id}`);
  return data;
};

export const createInstallation = async (params) => {
  const { data } = await api.post('/installations', params);
  return data;
};

export const updateInstallation = async (id, params) => {
  const { data } = await api.put(`/installations/${id}`, params);
  return data;
};

export const deleteInstallation = async (id) => {
  const { data } = await api.delete(`/installations/${id}`);
  return data;
};

export const updateInstallationProducts = async (id, productIds) => {
  const { data } = await api.put(`/installations/${id}/products`, { product_ids: productIds });
  return data;
};

export const bulkUpdateInstallationStoreStatus = async (installationIds, storeId, status) => {
  const { data } = await api.put('/installations/bulk-store-status', { installation_ids: installationIds, store_id: storeId, status });
  return data;
};
export const bulkDeleteInstallations = async (installationIds) => {
  const { data } = await api.delete('/installations/bulk-delete', { data: { installation_ids: installationIds } });
  return data;
};

export const importInstallations = async (items) => {
  const { data } = await api.post('/installations/import', { items });
  return data;
};

export const exportInstallationsCsv = async () => {
  const token = localStorage.getItem('token');
  return fetch('/api/installations/export-csv', { headers: { Authorization: `Bearer ${token}` } });
};

export const pushInstallationToShopify = async (id, storeId) => {
  const { data } = await api.post(`/installations/${id}/push`, { store_id: storeId });
  return data;
};

export const searchShopifyForInstallation = async (storeId, query) => {
  const { data } = await api.get('/installations/search-shopify', { params: { store_id: storeId, query } });
  return data;
};

export const matchInstallation = async (id, storeId, shopifyProductId) => {
  const { data } = await api.put(`/installations/${id}/match`, { store_id: storeId, shopify_product_id: shopifyProductId });
  return data;
};

export const unmatchInstallation = async (id, storeId) => {
  const { data } = await api.put(`/installations/${id}/unmatch`, { store_id: storeId });
  return data;
};

export const updateInstallationShopifyStatus = async (id, storeId, shopifyStatus) => {
  const { data } = await api.put(`/installations/${id}/shopify-status`, { store_id: storeId, shopify_status: shopifyStatus });
  return data;
};
